module.exports = __webpack_public_path__ + "img/logo-notagline.a117d4f0.png";